import React from 'react'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Blog.scss'


const Blog = () => {
  return (
    
    <>
      
    <div className='app__blog-container'>
    <h2 className='head-text'>Here's my Blog 😊</h2>
    <h6 className='head-text blog-text'>You may also check out my blog @<a href="https://ubcodesblog.com" target='_blank' rel='noreferrer' >ubcodesblog.com</a></h6>
    <p className='p-text'>Stay connected and be the first to access exclusive content by subscribing to my Telegram channel and newsletter. By joining, you'll receive a steady stream of inspiring and relevant content that will fuel your personal and professional growth. Don't miss out on valuable insights and resources that can elevate your journey. Subscribe today and stay informed!</p>
     <iframe
       src="https://ubcodesblog.com/"
       title='Ubcodes Blog'
      className='app__blog-iframe'
      allowFullScreen
      allow-scripts='true'
     >

     </iframe>
    </div>
    </>
  )
}

export default AppWrap(
   MotionWrap( Blog, 'app__blog' ),
   'blog',
   "app__whitebg"
   );
